module.exports = __webpack_public_path__ + "files/SPADI2021 - GESTION MANIPULATIONS RETRAIT CVC EN NEONATOLOGIE-V1.3a65890c35edce9fe6e0d18355d20678.pdf";